// vendor modules
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

/* eslint-disable */
import isFeatureEnabled from "shared/featureflags/helperFunctions"
/* eslint-disable */
import {
    politicalCommitteeProfileSelectorsMobile,
    selectPoliticalCommitteeSections,
} from "app/static/frontend/profiles-new/routes/political-committee/selectors.jsx"
import { checkHasOnlyRegionsWithin, checkPermission } from "shared/imports/permissionFunctions"
import { applyInitialFilters } from "shared/search/action-creators"
import { PersonifiedFilterSet } from "shared/search/containers/FilterSet/filterPersonification"
import { canDisplayBulkActionsConsole } from "shared/search/searchify/bulkactions/helperFunctions"

// components
import FilterableListView from "shared/search/containers/FilterableListView/index"

import {
    // less interesting inlines from here on out
    ActionCenterSettingsInline,
    AgencyInline,
    AlertGroupInline,
    AlertInline,
    AmendmentInline,
    ArticleInline,
    ArticleTopicInline,
    AssignmentInline,
    AttachmentInline,
    BeatInline,
    BillInline,
    BulkEmailInline,
    BulkSMSInline,
    BulkUploadFileInline,
    CampaignFinanceDisbursementInline,
    CampaignFinanceDisbursementDisabledInline,
    CampaignFinanceReceiptInline,
    CampaignFinanceReceiptDisabledInline,
    CampaignInline,
    CaucusInline,
    CommitteeInline,
    CountryInline,
    CountyInline,
    CustomDataInline,
    CustomEventParticipantInline,
    CustomRegionInline,
    DistrictInline,
    DocketInline,
    DocumentInline,
    ElectionInline,
    EventInline,
    EventParticipantInline,
    FeedItemInline,
    FileInline,
    GeoShapeInline,
    GrassrootsActionInline,
    IssueInline,
    IssueManagementInline,
    LegislativeSessionInline,
    LiveTranscriptInline,
    LowerLDInline,
    MunicipalityInline,
    NewListInline,
    NoteInline,
    OfficialInline,
    OrganizationInline,
    PacClassicPacOfficeInline,
    PacClassicPacOrganizationInline,
    PacClassicPacTransactionInline,
    PersonRoleInline,
    PoliticalCommitteeInline,
    PressContactInline,
    PublicOrganizationInline,
    RegulationCommentInline,
    RegulationInline,
    ReplyEmailInline,
    SendEmailInline,
    SendEmailInlineInProfile,
    SendSMSInline,
    StafferInline,
    StafferTermInline,
    StafferTitleInline,
    StatInline,
    StateInline,
    SupporterInline,
    TeamInline,
    TrackingDashboardInline,
    TransactionInline,
    UpperLDInline,
    UserInline,
    VoteInline,
    VoteResultInline,
    WitnessInline,
} from "app/static/frontend/search-new/containers/Inline/Inlines"

import { AmendmentOrderByFilterGroup } from "shared/search/containers/FilterGroup/AmendmentFilterGroups"
import { ArticleOrderByFilterGroup } from "shared/search/containers/FilterGroup/ArticleFilterGroups"
import { BillOrderByFilterGroup } from "shared/search/containers/FilterGroup/BillFilterGroups"
import { DocketOrderByFilterGroup } from "shared/search/containers/FilterGroup/DocketFilterGroups"
import { DocumentOrderByFilterGroup } from "shared/search/containers/FilterGroup/DocumentFilterGroups"
import { EventOrderByFilterGroup } from "shared/search/containers/FilterGroup/EventFilterGroups"
import { FileOrderByFilterGroup } from "shared/search/containers/FilterGroup/FileFilterGroups"
import { NoteOrderByFilterGroup } from "shared/search/containers/FilterGroup/NoteFilterGroups"
import { PublicOrganizationOrderByFilterGroup } from "shared/search/containers/FilterGroup/PublicOrganizationFilterGroups"
import { RegulationOrderByFilterGroup } from "shared/search/containers/FilterGroup/RegulationFilterGroups"
import { SendEmailOrderByFilterGroup } from "shared/search/containers/FilterGroup/SendEmailFilterGroups"
import { SendSMSOrderByFilterGroup } from "shared/search/containers/FilterGroup/SendEmailFilterGroups"
import { SupporterOrderByFilterGroup } from "shared/search/containers/FilterGroup/SupporterFilterGroups"
import { VoteOrderByFilterGroup } from "shared/search/containers/FilterGroup/VoteFilterGroups"

import genericFilterSet, {
    AgencyFilterSet,
    AlertFilterSet,
    AlertGroupFilterSet,
    AmendmentFilterSet,
    // profiles
    AmendmentInCommitteeProfileFilterSet,
    ArticleFilterSet,
    ArticleTopicFilterSet,
    AssignmentFilterSet,
    BillFilterSet,
    BillInCommitteeProfileFilterSet,
    BillInOfficialProfileFilterSet,
    BillInOrganizationProfileFilterSet,
    BulkEmailFilterSet,
    BulkSMSFilterSet,
    CampaignFilterSet,
    CampaignFinanceDisbursementsFilterSet,
    CampaignFinanceReceiptFilterSet,
    CaucusFilterSet,
    CommitteeFilterSet,
    CustomDataGeographicFilterSet,
    CustomEventParticipantFilterSet,
    DocketFilterSet,
    DocumentExcludeSourceFilterSet,
    DocumentFilterSet,
    DocumentInCommitteeProfileFilterSet,
    DocumentInOrganizationProfileFilterSet,
    DocumentMembersInOrganizationProfileFilterSet,
    ElectionFilterSet,
    EventFilterSet,
    EventInCommitteeProfileFilterSet,
    EventInOrganizationProfileFilterSet,
    EventParticipantFilterSet,
    ExecutiveFilterSet,
    FeedItemFilterSet,
    FileFilterSet,
    GeoShapeFilterSet,
    GeoShapeForBriefBuilderFilterSet,
    GeographyFilterSet,
    GeographyMunicipalityFilterSet,
    GeographyStateFilterSet,
    GrassrootsActionFilterSet,
    GrassrootsActionInOrganizationProfileFilterSet,
    IssueManagementFilterSet,
    IssuesFilterSet,
    LegislatorFilterSet,
    LiveTranscriptFilterSet,
    NoteFilterSet,
    NoteInOrganizationProfileFilterSet,
    NoteInCalendarEventWidgetFilterSet,
    OfficialAndStaffEUFilterSet,
    OfficialFilterSet,
    OfficialInBillProfileFilterSet,
    OfficialInOrganizationProfileFilterSet,
    // outbox
    OfficialInOutboxFilterSet,
    PacClassicPacOfficeFilterSet,
    PacClassicPacOrganizationFilterSet,
    PacClassicPacTransactionFilterSet,
    PacClassicPacTransactionInPacOrgFilterSet,
    PacClassicPacTransactionInOfficialFilterSet,
    PacClassicPacTransactionInSupporterFilterSet,
    PoliticalCommitteeFilterSet,
    PressContactFilterSet,
    PublicOrganizationFilterSet,
    PublicOrganizationInOrganizationProfileFilterSet,
    RegulationCommentFilterSet,
    RegulationFilterSet,
    ReplyEmailFilterSet,
    ReplyEmailTruncatedFilterSet,
    SendEmailFilterSet,
    SendSMSFilterSet,
    SocialDocumentFilterSet,
    StafferFilterSet,
    StafferInCommitteeProfileFilterSet,
    StafferInOfficialProfileFilterSet,
    StatisticFilterSet,
    SupporterFilterSet,
    SupporterInOrganizationProfileFilterSet,
    TeamFilterSet,
    TransactionFilterSet,
    UserFilterSet,
    VoteFilterSet,
    VoteInBillProfileFilterSet,
    VoteResultFilterSet,
    PoliticalCommitteeCampaignFinanceFilterSet,
    LegislatorFilterSetWithoutCampaignFinance,
    OfficialWitoutCampaignFinanceFilterSet,
} from "shared/search/containers/FilterSet/FilterSets"

import {
    // groups and group helpers
    AddContactButtonGroup,
    AddFileButton,
    AdvocatesButtonGroup,
    AdvocatesMessageGroup,
    BulkActionsButton,
    CreateAlertButton,
    CreateGrassrootsSupporterActionButton,
    CreateOfficialButton,
    CreateOrganizationButton,
    CreatePoliticalCommitteeButton,
    DisplayCalendarButton,
    DisplayNetworkGraphButton,
    DisplayVisualizationsButton,
    DownloadExcelButton,
    DownloadGroupByCustomFieldButton,
    DownloadSearchPDFButton,
    DownloadSpreadsheetButton,
    DownloadVCardButton,
    DownloadWordButton,
    GrassrootsActionsButtonGroup,
    GroupedActionsButtonGroup,
    NoteViewsButtonGroup,
    PublicOrganizationActionsButtonGroup,
    SaveToListButton,
    SubscribeToCalendarButton,
    TableViewButton,
    createAddNoteButtonGroup,
    createDownloadButtonGroup,
    createNewIssueButton,
    createOrderByButtonGroup,
} from "app/static/frontend/search-new/containers/FilterableListView/ActionButtons"

import BulkActionsConsole from "app/static/frontend/search-new/containers/BulkActions/BulkActionsConsole"

import {
    AmendmentVisualizationConsole,
    ArticleVisualizationConsole,
    BillVisualizationConsole,
    CommitteeVisualizationConsole,
    DocumentVisualizationConsole,
    EventVisualizationConsole,
    GrassrootsActionVisualizationConsole,
    NoteVisualizationConsole,
    OfficialVisualizationConsole,
    PressContactVisualizationConsole,
    PublicOrganizationVisualizationConsole,
    ReceiptsVisualizationConsole,
    RegulationVisualizationConsole,
    StafferVisualizationConsole,
    SupporterVisualizationConsole,
    VoteResultVisualizationConsole,
    VoteVisualizationConsole,
} from "app/static/frontend/search-new/containers/Visualization/VisualizationConsole/VisualizationConsoles"

import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"
import { shouldHideLocalOfficialsContact } from "shared/userdata/userdata-selectors"
import { isGrassrootsPersona } from "shared/grassroots/helperFunctions"
import { AddGrassrootsSupporterButtonGroup } from "app/static/frontend/search-new/containers/FilterableListView/ActionButtons"

import { CURRENT_YEAR, OFFICIAL_FLV } from "shared/imports/sharedConstants"

export function genericFilterableListView(props) {
    return (
        <FilterableListView
            quorumDataType={props.quorumDataType}
            filterSetComponent={props.filterSetComponent}
            inlineComponent={props.inlineComponent}
            {...props}
        />
    )
}

genericFilterableListView.propTypes = {
    quorumDataType: PropTypes.number.isRequired,
    filterSetComponent: PropTypes.func.isRequired,
    inlineComponent: PropTypes.func.isRequired,
}

export function genericSearchifySelectFLV(props) {
    return (
        <FilterableListView
            resource={props.resource}
            filterSetComponent={genericFilterSet}
            inlineComponent={props.inlineComponent}
            isOnlyTableView={props.isOnlyTableView}
            {...props}
        />
    )
}
genericSearchifySelectFLV.propTypes = {
    resource: PropTypes.object.isRequired,
    inlineComponent: PropTypes.func.isRequired,
}

/**
 * Helper to merge permanentFilters and profileInitialFilters rather than overwrite them
 * @param {object}  props
 * @param {func}    parentComp [reference to parent comp calling this which has `defaultProps`]
 * @return {object} props
 */
export const mergeProps = (props, parentComp) => ({
    ...props,
    permanentFilters: {
        ...(parentComp.defaultProps || {}).permanentFilters,
        ...props.permanentFilters,
    },
    profileInitialFilters: {
        ...(parentComp.defaultProps || {}).profileInitialFilters,
        ...props.profileInitialFilters,
    },
})

export const overrideDefaultProps = (defaultProps, overrideProps) => ({ ...defaultProps, ...overrideProps })

export const OfficialFilterableWithoutCampaignFinanceListView = (props) =>
    genericFilterableListView(mergeProps(props, OfficialFilterableWithoutCampaignFinanceListView))
OfficialFilterableWithoutCampaignFinanceListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: PersonifiedFilterSet(OfficialWitoutCampaignFinanceFilterSet),
    // officials show every PersonType except staffers.
    permanentFilters: {
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.items()
            .filter((val) => val.is_official)
            .map((val) => val.value),
        dehydrate_extra: ["alignment", "most_recent_role", "priority"],
    },
    searchPlaceholderText: "Search officials by name...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, OfficialVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: OfficialVisualizationConsole,
}

export const OfficialFilterableListView = (props) => {
    let newProps = props
    if (props.isDashboard || props.isOutbox) {
        newProps = {
            ...props,
            filterSetComponent: OfficialWitoutCampaignFinanceFilterSet,
        }
    }

    if (isFeatureEnabled("ff_custom_official") && Userdata.admin_can_create_custom_official) {
        newProps = {
            ...props,
            actionButtons: [CreateOfficialButton, ...props.actionButtons],
        }
    }

    return genericFilterableListView(mergeProps(newProps, OfficialFilterableWithoutCampaignFinanceListView))
}

OfficialFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: PersonifiedFilterSet(OfficialFilterSet),
    // officials show every PersonType except staffers.
    permanentFilters: {
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.items()
            .filter((val) => val.is_official)
            .map((val) => val.value),
        dehydrate_extra: ["alignment", "most_recent_role", "priority"],
    },
    searchPlaceholderText: "Search officials by name...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, OfficialVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: OfficialVisualizationConsole,
}

export const StafferFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, StafferFilterableListView))
StafferFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.staffer.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: StafferInline,
    filterSetComponent: PersonifiedFilterSet(StafferFilterSet),
    permanentFilters: {
        hygiene_staffer_types: true,
        dehydrate_extra: ["alignment", "committee", "location", "most_recent_role", "person", "priority"],
    },
    profileInitialFilters: {
        current: true,
    },
    searchPlaceholderText: "Search staffers by name...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, StafferVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: StafferVisualizationConsole,
}

export const PressContactFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PressContactFilterableListView))

PressContactFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.press_contact.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: PressContactInline,
    filterSetComponent: PressContactFilterSet,
    permanentFilters: {
        most_recent_person_type: DjangIO.app.person.types.PersonType.press_contact.value,
        dehydrate_extra: ["media_organizations", "beats"],
    },
    initialFilters: {
        current: true,
    },
    searchPlaceholderText: "Search press by name...",
    leftActionButtons: [TableViewButton, PressContactVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: PressContactVisualizationConsole,
}

export const OfficialsAndStaffEUFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, OfficialsAndStaffEUFilterableListView))
OfficialsAndStaffEUFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: OfficialAndStaffEUFilterSet,
    searchPlaceholderText: "Search people by name...",
    permanentFilters: {
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.items()
            .filter((personType) => personType.value !== DjangIO.app.person.types.PersonType.press_contact.value)
            .map((personType) => personType.value),
        dehydrate_extra: [
            "alignment",
            "most_recent_country",
            "most_recent_role",
            "person_biography_role_data",
            "priority",
        ],
    },
    actionButtons: [
        ...(isFeatureEnabled("ff_custom_official") && Userdata.admin_can_create_custom_official
            ? [CreateOfficialButton]
            : []),
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, OfficialVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: OfficialVisualizationConsole,
}

export const getBillFLVPermanentFilters = () => {
    // now this is an interesting edge case
    // let's say that someone has Federal + Grassroots. In this case, they have
    // legislative data for most regions, but only have legislative profiles for 1 region
    // (federal). If they go to all regions, they can see the bills dataset (due to Federal permissions)
    // and they can see the state bills themselves (due to State grassroots permissions)
    // so: if in the region someone is in they have regions that are present in
    // legislative profiles but not in legislative data, we need to filter for just those regions
    const currentRegionsValues = new Set(Userdata.current_regions_values)

    const legislativeProfiles = new Set(
        Userdata.Permissions.qp_legislative_profiles.filter((region) => currentRegionsValues.has(region)),
    )
    const legislativeData = new Set(
        Userdata.Permissions.qp_legislative_data.filter((region) => currentRegionsValues.has(region)),
    )

    const isSetsEqual = (a, b) => a.size === b.size && [...a].every((value) => b.has(value))

    const shouldHavePermanentFilter =
        !isSetsEqual(legislativeProfiles, legislativeData) && legislativeProfiles && legislativeProfiles.size

    let filters = {
        dehydrate_extra: ["priority", "stance", "issues"],
    }

    if (shouldHavePermanentFilter) {
        filters["region__in"] = [...legislativeProfiles]
    }

    /* set language for non English speaking international regions */
    if (Userdata.current_regions_values.length === 1) {
        const languages = [].concat(
            ...DjangIO.app.bill.types.language.BillLanguage.items().map((bl) =>
                bl.supported_regions.some((elem) => Userdata.current_regions_values[0] === elem) ? [bl.value] : [],
            ),
        )

        if (languages.length === 1 && languages[0] !== DjangIO.app.bill.types.language.BillLanguage.english.value) {
            filters["language"] = languages.toString()
        }
    }

    return filters
}

export const BillFilterableListView = (props) => {
    let newProps = props
    const { ai_search, introduced_date__lt, introduced_date__gt, introduced_date_range, in_sessions } =
        props?.location?.query || {}

    if (ai_search && (introduced_date_range || introduced_date__lt || introduced_date__gt || in_sessions)) {
        newProps = {
            ...props,
            initialFilters: {},
        }
        return genericFilterableListView(mergeProps(newProps, BillFilterableListView))
    }

    return genericFilterableListView(mergeProps(props, BillFilterableListView))
}

BillFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.bill.value,
    resource: DjangIO.app.bill.models.NewBill,
    inlineComponent: BillInline,
    filterSetComponent: PersonifiedFilterSet(BillFilterSet),
    searchPlaceholderText: "Search bills by title or text...",
    permanentFilters: getBillFLVPermanentFilters(),
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.bill.value,
            uniqueFilterId: BillOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        BillVisualizationConsole && DisplayVisualizationsButton,
    ].filter((item) => !!item),
    initialFilters: {
        for_years: [CURRENT_YEAR, CURRENT_YEAR - 1],
    },
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: BillVisualizationConsole,
}

export const DocumentFilterableListView = (props) => {
    let newProps = props

    if (props?.uniqueFlvId !== "DocumentDefaultSearch") {
        newProps = {
            ...props,
            initialFilters: {},
        }
        return genericFilterableListView(mergeProps(newProps, DocumentFilterableListView))
    }

    const { ai_search, date_range, date__lt, date__gt, in_sessions } = props?.location?.query || {}
    if (ai_search && (date_range || date__lt || date__gt || in_sessions)) {
        newProps = {
            ...props,
            initialFilters: {},
        }
        return genericFilterableListView(mergeProps(newProps, DocumentFilterableListView))
    }

    return genericFilterableListView(mergeProps(props, DocumentFilterableListView))
}

DocumentFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.document.value,
    resource: DjangIO.app.document.models.NewDocument,
    inlineComponent: DocumentInline,
    filterSetComponent: PersonifiedFilterSet(DocumentFilterSet),
    permanentFilters: {
        // this is so duplicates don't appear if the database pulls in
        // more documents in between the initial load and 'loading more'
        // (it will refresh if the user exits the FLV and then reloads,
        // we might need to finesse this later)
        created__lte: moment().format(),
        dehydrate_extra: ["committee_meeting", "official_image", "stance"],
    },
    getRefreshablePermanentFilters: () => ({
        created__lte: moment().format(),
    }),
    searchPlaceholderText: "Search tweets, letters, and more...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.document.value,
            uniqueFilterId: DocumentOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        DocumentVisualizationConsole && DisplayVisualizationsButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    initialFilters: {
        date_range: DjangIO.app.events.models.DateRangeType.this_year.value,
    },
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: DocumentVisualizationConsole,
}

export const RegulationDocumentFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, RegulationDocumentFilterableListView))
RegulationDocumentFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.document.value,
    resource: DjangIO.app.document.models.RegDocument,
    inlineComponent: DocumentInline,
    filterSetComponent: DocumentFilterSet,
    permanentFilters: {
        // this is so duplicates don't appear if the database pulls in
        // more documents in between the initial load and 'loading more'
        // (it will refresh if the user exits the FLV and then reloads,
        // we might need to finesse this later)
        created__lte: moment().format(),
    },
    getRefreshablePermanentFilters: () => ({
        created__lte: moment().format(),
    }),
    searchPlaceholderText: "Search regulation documents...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [DocumentVisualizationConsole && DisplayVisualizationsButton].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: DocumentVisualizationConsole,
}

export const SupporterFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, SupporterFilterableListView))
SupporterFilterableListView.defaultProps = {
    plusButton: {
        title: "Create Contact",
        sceneKey: "contactForm",
        iconName: "user-plus",
    },
    quorumDataType: DjangIO.app.models.QuorumDataType.supporter.value,
    inlineComponent: SupporterInline,
    filterSetComponent: PersonifiedFilterSet(SupporterFilterSet),
    searchPlaceholderText: "Search contacts by name or email...",
    actionButtons: [
        ...(isGrassrootsPersona()
            ? [AdvocatesButtonGroup].filter((item) => !!item)
            : [
                  AddContactButtonGroup,
                  CreateAlertButton,
                  ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management)
                      ? [SaveToListButton]
                      : []),
                  ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
                  createDownloadButtonGroup([
                      DownloadSpreadsheetButton,
                      DownloadExcelButton,
                      DownloadWordButton,
                      DownloadSearchPDFButton,
                      DownloadVCardButton,
                      ...(isFeatureEnabled("ff_group_by_custom_fields_csv") ? [DownloadGroupByCustomFieldButton] : []),
                  ]),
              ].filter((item) => !!item)),
    ],
    leftActionButtons: [
        ...(isGrassrootsPersona()
            ? [
                  TableViewButton,
                  createOrderByButtonGroup({
                      qdt: DjangIO.app.models.QuorumDataType.supporter.value,
                      uniqueFilterId: SupporterOrderByFilterGroup.defaultProps.uniqueFilterId,
                  }),
                  AdvocatesMessageGroup,
                  SupporterVisualizationConsole && DisplayVisualizationsButton,
                  ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
              ].filter((item) => !!item)
            : [
                  TableViewButton,
                  createOrderByButtonGroup({
                      qdt: DjangIO.app.models.QuorumDataType.supporter.value,
                      uniqueFilterId: SupporterOrderByFilterGroup.defaultProps.uniqueFilterId,
                  }),
                  SupporterVisualizationConsole && DisplayVisualizationsButton,
              ].filter((item) => !!item)),
    ],
    groupedActionButtons: [
        AddContactButtonGroup,
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
            ...(isFeatureEnabled("ff_group_by_custom_fields_csv") ? [DownloadGroupByCustomFieldButton] : []),
        ]),
    ].filter((item) => !!item),
    rightGroupedActionButtons: [
        AddContactButtonGroup,
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
            DownloadVCardButton,
            ...(isFeatureEnabled("ff_group_by_custom_fields_csv") ? [DownloadGroupByCustomFieldButton] : []),
        ]),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: SupporterVisualizationConsole,
    permanentFilters: {
        dehydrate_extra: ["alignment", "priority", "individuals_information"],
    },
}

export const PublicOrganizationFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PublicOrganizationFilterableListView))
PublicOrganizationFilterableListView.defaultProps = {
    plusButton: {
        title: "Create Organization",
        sceneKey: "organizationForm",
        iconName: "plus",
    },
    quorumDataType: DjangIO.app.models.QuorumDataType.public_organization.value,
    inlineComponent: PublicOrganizationInline,
    filterSetComponent: PersonifiedFilterSet(PublicOrganizationFilterSet),
    searchPlaceholderText: "Search organizations...",
    actionButtons: [
        CreateOrganizationButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.public_organization.value,
            uniqueFilterId: PublicOrganizationOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        PublicOrganizationVisualizationConsole && DisplayVisualizationsButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        PublicOrganizationActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: PublicOrganizationVisualizationConsole,
    permanentFilters: {
        dehydrate_extra: ["beats", "market_areas"],
        // Calling this querymethod ensures Media Monitoring and Comms permissioning are applied.
        // When true, Outlets will show up in search if the user has the Comms product.
        default_for_user: true,
    },
    // Organizations can have multiple aliases, which leads to having in the results.
    // We didn't figure out an efficient way to handle this on the querymethod, so we filter here.
    filterCurrentData: (currentData) => {
        const idSet = new Set()

        const uniqById = (datum) => {
            const datumId = datum.get && datum.get("id")
            const isDuplicate = idSet.has(datumId)

            // eslint-disable-next-line no-unused-expressions
            !isDuplicate && idSet.add(datumId)

            return !isDuplicate
        }

        return currentData.filter(uniqById)
    },
}

export const NoteFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps(
            {
                ...props,
                actionButtons: [createAddNoteButtonGroup(props), ...props.actionButtons].filter((item) => !!item),
                groupedActionButtons: [
                    createAddNoteButtonGroup(props),
                    GroupedActionsButtonGroup,
                    createDownloadButtonGroup([
                        DownloadSpreadsheetButton,
                        DownloadExcelButton,
                        DownloadWordButton,
                        DownloadSearchPDFButton,
                    ]),
                ].filter((item) => !!item),
                rightGroupedActionButtons: [
                    createAddNoteButtonGroup(props),
                    GroupedActionsButtonGroup,
                    createDownloadButtonGroup([
                        DownloadSpreadsheetButton,
                        DownloadExcelButton,
                        DownloadWordButton,
                        DownloadSearchPDFButton,
                    ]),
                ].filter((item) => !!item),
            },
            NoteFilterableListView,
        ),
    )
NoteFilterableListView.defaultProps = {
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.note.value,
            uniqueFilterId: NoteOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        NoteVisualizationConsole && DisplayVisualizationsButton,
        DisplayNetworkGraphButton,
        DisplayCalendarButton,
    ].filter((item) => !!item),
    leftGroupedActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.note.value,
            uniqueFilterId: NoteOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        NoteViewsButtonGroup,
    ].filter((item) => !!item),
    plusButton: undefined,
    multiPlusButtons: [
        // in order of least important -> most important
        {
            title: "Record Donation",
            sceneKey: "logDonation",
            iconName: "gift",
        },
        {
            title: "Write Comment",
            sceneKey: "logComment",
            iconName: "pencil-square-o",
        },
        {
            title: "Create Relationship",
            sceneKey: "logRelationship",
            iconName: "exchange",
        },
        {
            title: "Log Interaction",
            sceneKey: "logInteraction",
            iconName: "plus",
        },
    ],
    quorumDataType: DjangIO.app.models.QuorumDataType.note.value,
    inlineComponent: NoteInline,
    filterSetComponent: PersonifiedFilterSet(NoteFilterSet),
    searchPlaceholderText: "Search notes and comments...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: NoteVisualizationConsole,
    permanentFilters: {
        dehydrate_extra: ["bills", "issues"],
        remove_resource_excludes: true,
    },
}

export const GrassrootsActionFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, GrassrootsActionFilterableListView))
GrassrootsActionFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.grassroots_action.value,
    resource: DjangIO.app.grassroots.models.GrassrootsSupporterAction,
    inlineComponent: GrassrootsActionInline,
    filterSetComponent: PersonifiedFilterSet(GrassrootsActionFilterSet),
    searchPlaceholderText: "Search actions...",
    actionButtons: [
        ...(Userdata.can_alter_pac_transactions || isFeatureEnabled("ff_permissions_for_pac_2")
            ? [AddGrassrootsSupporterButtonGroup]
            : [CreateGrassrootsSupporterActionButton]),
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, GrassrootsActionVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    groupedActionButtons: [
        GrassrootsActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: GrassrootsActionVisualizationConsole,
    permanentFilters: {
        dehydrate_extra: ["campaign", "charity_name", "story_video"],
    },
}

export const EventFilterableListView = (props) => genericFilterableListView(mergeProps(props, EventFilterableListView))
EventFilterableListView.defaultProps = {
    resource: DjangIO.app.events.models.NewEvent,
    quorumDataType: DjangIO.app.models.QuorumDataType.event.value,
    inlineComponent: EventInline,
    filterSetComponent: PersonifiedFilterSet(EventFilterSet),
    searchPlaceholderText: "Search meetings and more...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            SubscribeToCalendarButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.event.value,
            uniqueFilterId: EventOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        ...(!checkHasOnlyRegionsWithin(DjangIO.app.models.SupportedRegion.local.child_regions) &&
        EventVisualizationConsole
            ? [DisplayVisualizationsButton]
            : []),
        DisplayCalendarButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            SubscribeToCalendarButton,
        ]),
    ].filter((item) => !!item),
    rightGroupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            SubscribeToCalendarButton,
        ]),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: EventVisualizationConsole,
    permanentFilters: {
        dehydrate_extra: ["committee", "manualtranscriptinfo"],
    },
}

export const VoteFilterableListView = (props) => genericFilterableListView(mergeProps(props, VoteFilterableListView))
VoteFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.vote.value,
    inlineComponent: VoteInline,
    filterSetComponent: VoteFilterSet,
    searchPlaceholderText: "Search votes...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.vote.value,
            uniqueFilterId: VoteOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        VoteVisualizationConsole && DisplayVisualizationsButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: VoteVisualizationConsole,
    permanentFilters: {
        dehydrate_extra: ["stance"],
    },
}

export const AmendmentFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AmendmentFilterableListView))
AmendmentFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.amendment.value,
    inlineComponent: AmendmentInline,
    filterSetComponent: AmendmentFilterSet,
    searchPlaceholderText: "Search amendments...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.amendment.value,
            uniqueFilterId: AmendmentOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        AmendmentVisualizationConsole && DisplayVisualizationsButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: AmendmentVisualizationConsole,
}

export const CommitteeFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, CommitteeFilterableListView))
CommitteeFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.committee.value,
    inlineComponent: CommitteeInline,
    filterSetComponent: CommitteeFilterSet,
    searchPlaceholderText: "Search committees...",
    actionButtons: [
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, CommitteeVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: CommitteeVisualizationConsole,
}

export const CaucusFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, CaucusFilterableListView))
CaucusFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.caucus.value,
    inlineComponent: CaucusInline,
    filterSetComponent: CaucusFilterSet,
    searchPlaceholderText: "Search caucuses by name...",
    actionButtons: [
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton, CommitteeVisualizationConsole && DisplayVisualizationsButton].filter(
        (item) => !!item,
    ),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: CommitteeVisualizationConsole,
}

export const FileFilterableListView = (props) => genericFilterableListView(mergeProps(props, FileFilterableListView))
FileFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.attachment.value,
    inlineComponent: FileInline,
    filterSetComponent: FileFilterSet,
    searchPlaceholderText: "Search caucuses by name...",
    actionButtons: [
        AddFileButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.attachment.value,
            uniqueFilterId: FileOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
}

export const CampaignFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, CampaignFilterableListView))
CampaignFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.campaign.value,
    inlineComponent: CampaignInline,
    filterSetComponent: CampaignFilterSet,
    searchPlaceholderText: "Search campaign by name...",
    permanentFilters: {
        activated__isnull: false,
    },
}

export const SendEmailFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps(
            {
                ...props,
                inlineComponent: props.inProfile ? SendEmailInlineInProfile : SendEmailInline,
            },
            SendEmailFilterableListView,
        ),
    )
SendEmailFilterableListView.defaultProps = {
    initialFilters: {
        date_range: DjangIO.app.events.models.DateRangeType.this_month.value,
    },
    permanentFilters: {
        dehydrate_extra: ["bulk_email"],
    },
    quorumDataType: DjangIO.app.models.QuorumDataType.send_email.value,
    filterSetComponent: SendEmailFilterSet,
    searchPlaceholderText: "Search sent emails by content...",
    labelSingular: "Outbox Email",
    labelPlural: "Outbox Emails",
    actionButtons: [
        CreateAlertButton,
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.send_email.value,
            uniqueFilterId: SendEmailOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
    ].filter((item) => !!item),
}

export const SendSMSFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps(
            {
                ...props,
                inlineComponent: SendSMSInline,
            },
            SendEmailFilterableListView,
        ),
    )
SendSMSFilterableListView.defaultProps = {
    initialFilters: {
        date_range: DjangIO.app.events.models.DateRangeType.this_month.value,
    },
    permanentFilters: {
        dehydrate_extra: ["bulk_sms"],
    },
    quorumDataType: DjangIO.app.models.QuorumDataType.send_sms.value,
    filterSetComponent: SendSMSFilterSet,
    searchPlaceholderText: "Search sent sms by content...",
    labelSingular: "Outbox Texts",
    labelPlural: "Outbox Texts",
    actionButtons: [].filter((item) => !!item),
    leftActionButtons: [TableViewButton].filter((item) => !!item),
}

export const BulkEmailFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, BulkEmailFilterableListView))
BulkEmailFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.bulk_email.value,
    inlineComponent: BulkEmailInline,
    filterSetComponent: BulkEmailFilterSet,
    // only display the sent emails
    permanentFilters: {
        is_draft: false,
        is_scheduled: false,
        excludes_truncation: true,
        dehydrate_extra: ["abtest_description"],
    },
    labelPlural: `${DjangIO.app.models.QuorumDataType.bulk_email.plural} (from last year)`,
    searchPlaceholderText: "Search Outbox emails...",
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
}

export const BulkSMSFilterableListView = (props) => {
    return genericFilterableListView(mergeProps(props, BulkSMSFilterableListView))
}
BulkSMSFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.bulk_sms.value,
    inlineComponent: BulkSMSInline,
    filterSetComponent: BulkSMSFilterSet,
    // only display the sent SMSs
    permanentFilters: {
        dehydrate_extra: ["creator"],
        exclude_drafts: true,
    },
    searchPlaceholderText: "Search Outbound Texts...",
    actionButtons: [],
}

export const ReplyEmailFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, ReplyEmailFilterableListView))
ReplyEmailFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.reply_email.value,
    inlineComponent: ReplyEmailInline,
    filterSetComponent: ReplyEmailFilterSet,
    permanentFilters: {
        dehydrate_extra: ["related_fields"],
    },
    searchPlaceholderText: "Search reply emails by content...",
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
}

export const ReplyEmailTruncatedFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, ReplyEmailTruncatedFilterableListView))
ReplyEmailTruncatedFilterableListView.defaultProps = overrideDefaultProps(ReplyEmailFilterableListView.defaultProps, {
    filterSetComponent: ReplyEmailTruncatedFilterSet,
})

export const EventBulkEmailFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, EventBulkEmailFilterableListView))
EventBulkEmailFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.bulk_email.value,
    inlineComponent: BulkEmailInline,
    filterSetComponent: BulkEmailFilterSet,
    // only display the sent emails
    searchPlaceholderText: "Search Outbox invtations for this event...",
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
}

export const EventParticipantFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, EventParticipantFilterableListView))
EventParticipantFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.event_participant.value,
    inlineComponent: EventParticipantInline,
    filterSetComponent: EventParticipantFilterSet,
}

export const LiveTranscriptFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, LiveTranscriptFilterableListView))
LiveTranscriptFilterableListView.defaultProps = {
    resource: DjangIO.app.events.models.Event,
    inlineComponent: LiveTranscriptInline,
    filterSetComponent: LiveTranscriptFilterSet,
    permanentFilters: {
        on_cspan: true,
    },
    labelSingular: "Live Transcript",
    labelPlural: "Live Transcripts",
    searchPlaceholderText: "Search live transcripts of CSPAN events...",
}

export const RegulationFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, RegulationFilterableListView))
RegulationFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.regulation.value,
    inlineComponent: RegulationInline,
    filterSetComponent: RegulationFilterSet,
    searchPlaceholderText: "Search for regulations...",
    permanentFilters: {
        dehydrate_extra: ["enhanced_agency_name", "issues", "pdf_url", "priority", "stance"],
    },
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.regulation.value,
            uniqueFilterId: RegulationOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        DisplayVisualizationsButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: RegulationVisualizationConsole,
}

export const RegulationCommentFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, RegulationCommentFilterableListView))
RegulationCommentFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.reg_comment.value,
    inlineComponent: RegulationCommentInline,
    filterSetComponent: RegulationCommentFilterSet,
    searchPlaceholderText: "Search for regulation comments...",
    actionButtons: [
        CreateAlertButton,
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    permanentFilters: { dehydrate_extra: "related_objects" },
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: RegulationVisualizationConsole,
}

/* ***************************************************************************
 * Searchify FLVs, could be fleshed out
 ***************************************************************************** */

export const NewListFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, NewListFilterableListView))
NewListFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.new_list.value,
    inlineComponent: NewListInline,
    filterSetComponent: genericFilterSet,
    searchPlaceholderText: "Search lists by name...",
    permanentFilters: { dehydrate_extra: "project_name" },
}

export const IssueManagementFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps(
            {
                ...props,
                actionButtons: [
                    createNewIssueButton && createNewIssueButton(props.profileId),
                    ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
                ].filter((item) => !!item),
            },
            IssueManagementFilterableListView,
        ),
    )
IssueManagementFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.issue_management.value,
    inlineComponent: IssueManagementInline,
    filterSetComponent: IssueManagementFilterSet,
    searchPlaceholderText: "Search issues by name...",
    permanentFilters: {
        dehydrate_extra: ["parent_name", "alignment_type_icon"],
    },
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
}

export const TrackingDashboardFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, TrackingDashboardFilterableListView))
TrackingDashboardFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.tracking_dashboard.value,
    inlineComponent: TrackingDashboardInline,
    filterSetComponent: genericFilterSet,
    searchPlaceholderText: "Search tracking boards by name...",
}

export const AttachmentFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AttachmentFilterableListView))
AttachmentFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.attachment.value,
    inlineComponent: AttachmentInline,
    filterSetComponent: genericFilterSet,
    searchPlaceholderText: "Search attachments by name...",
}

export const UserFilterableListView = (props) => genericFilterableListView(mergeProps(props, UserFilterableListView))
UserFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.user.value,
    inlineComponent: UserInline,
    filterSetComponent: UserFilterSet,
    searchPlaceholderText: "Search users by name...",
}

export const AllUserFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AllUserFilterableListView))
AllUserFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.user.value,
    inlineComponent: UserInline,
    filterSetComponent: genericFilterSet,
    searchPlaceholderText: "Search users by name...",
    permanentFilters: {
        default_for_user: false,
    },
}

export const StatisticFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, StatisticFilterableListView))
StatisticFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.statistic.value,
    inlineComponent: StatInline,
    filterSetComponent: StatisticFilterSet,
}

export const VoteResultFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, VoteResultFilterableListView))
VoteResultFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.vote_result.value,
    inlineComponent: VoteResultInline,
    filterSetComponent: VoteResultFilterSet,
    searchPlaceholderText: "Search vote results by legislator...",
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    leftActionButtons: [DisplayVisualizationsButton].filter((item) => !!item),
    permanentFilters: {
        dehydrate_extra: ["related_fields"],
    },
    visualizationConsole: VoteResultVisualizationConsole,
}

export const PersonRoleFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PersonRoleFilterableListView))
PersonRoleFilterableListView.defaultProps = {
    resource: DjangIO.app.person.models.PersonRole,
    inlineComponent: PersonRoleInline,
    filterSetComponent: genericFilterSet,
    searchPlaceholderText: "Search role history by legislator...",
    labelSingular: "Role",
    labelPlural: "Roles",
}

export const AlertFilterableListView = (props) => genericFilterableListView(mergeProps(props, AlertFilterableListView))
AlertFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.alert.value,
    resource: DjangIO.app.userdata.alerts.models.Alert,
    inlineComponent: AlertInline,
    filterSetComponent: AlertFilterSet,
    searchPlaceholderText: "Search alerts...",
    actionButtons: canDisplayBulkActionsConsole() ? [BulkActionsButton].filter((item) => !!item) : undefined,
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
}

export const AlertGroupFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AlertGroupFilterableListView))
AlertGroupFilterableListView.defaultProps = {
    resource: DjangIO.app.userdata.alerts.models.AlertGroup,
    inlineComponent: AlertGroupInline,
    filterSetComponent: Userdata.is_admin ? AlertGroupFilterSet : genericFilterSet,
    labelSingular: "Alert Group",
    labelPlural: "Alert Groups",
    searchPlaceholderText: "Search alert groups...",
}

export const AlertFeedItemFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AlertFeedItemFilterableListView))
AlertFeedItemFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.alert.value,
    resource: DjangIO.app.userdata.alerts.models.FeedItem,
    inlineComponent: FeedItemInline,
    filterSetComponent: FeedItemFilterSet,
    searchPlaceholderText: "Search alert items...",
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    leftActionButtons: [TableViewButton].filter((item) => !!item),
    permanentFilters: {
        dehydrate_extra: ["alert", "priority_stance_alignment"],
    },
}

export const AssignmentFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AssignmentFilterableListView))
AssignmentFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.assignment.value,
    inlineComponent: AssignmentInline,
    filterSetComponent: AssignmentFilterSet,
    searchPlaceholderText: "Search assignments...",
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    permanentFilters: { dehydrate_extra: "related_objects" },
}

export const BulkUploadFileFLV = (props) => genericFilterableListView(mergeProps(props, BulkUploadFileFLV))
BulkUploadFileFLV.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.bulk_upload.value,
    inlineComponent: BulkUploadFileInline,
    filterSetComponent: genericFilterSet,
    searchPlaceholderText: "Search bulk upload files...",
    actionButtons: [],
}

export const DocketFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, DocketFilterableListView))
DocketFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.docket.value,
    resource: DjangIO.app.reg.models.Docket,
    inlineComponent: DocketInline,
    filterSetComponent: DocketFilterSet,
    searchPlaceholderText: "Search dockets...",
    actionButtons: [
        CreateAlertButton,
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.docket.value,
            uniqueFilterId: DocketOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
    ].filter((item) => !!item),
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    permanentFilters: {
        dehydrate_extra: ["priority", "stance"],
    },
}

export const CustomEventParticipantFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, CustomEventParticipantFilterableListView))
CustomEventParticipantFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.custom_event_participant.value,
    inlineComponent: CustomEventParticipantInline,
    filterSetComponent: CustomEventParticipantFilterSet,
    searchPlaceholderText: "Search for custom event participants...",
    permanentFilters: {
        dehydrate_extra: ["related_fields"],
    },
    actionButtons: [
        createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton]),
    ].filter((item) => !!item),
}

export const ArticleFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, ArticleFilterableListView))

ArticleFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.media.value,
    resource: DjangIO.app.media_monitoring.models.Article,
    filterSetComponent: ArticleFilterSet,
    applyInitialFilters,
    initialFilters: {
        estimated_published_date_range: DjangIO.app.events.models.DateRangeType.today.value,
        language: DjangIO.app.document.types.Language.english.value,
    },
    inlineComponent: ArticleInline,
    permanentFilters: {
        archived: false,
        dehydrate_extra: ["priority", "stance"],
    },
    getRefreshablePermanentFilters: () => ({}),
    searchPlaceholderText: "Search articles and the news...",
    actionButtons: [
        CreateAlertButton,
        ...(checkPermission(DjangIO.app.models.PermissionType.can_access_issue_management) ? [SaveToListButton] : []),
        ...(canDisplayBulkActionsConsole() ? [BulkActionsButton] : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ].filter((item) => !!item),
    leftActionButtons: [
        TableViewButton,
        createOrderByButtonGroup({
            qdt: DjangIO.app.models.QuorumDataType.media.value,
            uniqueFilterId: ArticleOrderByFilterGroup.defaultProps.uniqueFilterId,
        }),
        DisplayVisualizationsButton,
    ].filter((item) => !!item),
    groupedActionButtons: [
        GroupedActionsButtonGroup,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    visualizationConsole: ArticleVisualizationConsole,
    visitedSearch: () =>
        sendUserActionPost({
            userActionType: DjangIO.app.useractions.types.UserActionType.visit_media_article_search,
            description: "Visited Media Articles Search",
            quorumDataType: DjangIO.app.models.QuorumDataType.media.value,
        }),
}

export const PoliticalCommitteeFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PoliticalCommitteeFilterableListView))

PoliticalCommitteeFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.political_committee.value,
    inlineComponent: PoliticalCommitteeInline,
    filterSetComponent: PersonifiedFilterSet(PoliticalCommitteeFilterSet),
    searchPlaceholderText: "Search political committees...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    applyInitialFilters,
    initialFilters: {
        political_committee_is_active: true,
    },
    actionButtons: [
        ...(checkPermission(DjangIO.app.models.PermissionType.pac_state_and_local_committees)
            ? [CreatePoliticalCommitteeButton]
            : []),
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    leftActionButtons: [TableViewButton],
}

export const PoliticalCommitteeCampaignFinanceFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PoliticalCommitteeCampaignFinanceFilterableListView))

PoliticalCommitteeCampaignFinanceFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.political_committee.value,
    inlineComponent: PoliticalCommitteeInline,
    filterSetComponent: PersonifiedFilterSet(PoliticalCommitteeCampaignFinanceFilterSet),
    searchPlaceholderText: "Search political committees...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    applyInitialFilters,
    initialFilters: {
        political_committee_is_active: true,
    },
}

export const PublicPacOrganizationFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PoliticalCommitteeFilterableListView))

PublicPacOrganizationFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.public_organization.value,
    inlineComponent: PublicOrganizationInline,
    filterSetComponent: PublicOrganizationFilterSet,
    searchPlaceholderText: "Search PAC organizations...",
    bulkActionsConsole: undefined,
    applyInitialFilters,
    initialFilters: {
        pac_org_type__isnull: false,
    },
}

export const TransactionFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, TransactionFilterableListView))

TransactionFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.transaction.value,
    inlineComponent: TransactionInline,
    filterSetComponent: PersonifiedFilterSet(TransactionFilterSet),
    searchPlaceholderText: "Search transactions...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    actionButtons: [
        // OfficialVisualizationConsole && DisplayVisualizationsButton,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            // DownloadSearchPDFButton TODO
        ]),
    ],
    leftActionButtons: [TableViewButton],
}

export const PacClassicPacOfficeFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PacClassicPacOfficeFilterableListView))

PacClassicPacOfficeFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.pacc_pac_office.value,
    inlineComponent: PacClassicPacOfficeInline,
    filterSetComponent: PersonifiedFilterSet(PacClassicPacOfficeFilterSet),
    searchPlaceholderText: "Search Elected Offices (PAC)...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    actionButtons: [],
    leftActionButtons: [TableViewButton],
    permanentFilters: {},
}

export const PacClassicPacOrganizationFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PacClassicPacOrganizationFilterableListView))
PacClassicPacOrganizationFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.pacc_pac_organization.value,
    inlineComponent: PacClassicPacOrganizationInline,
    filterSetComponent: PersonifiedFilterSet(PacClassicPacOrganizationFilterSet),
    searchPlaceholderText: "Search PAC Organizations (PAC)...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    actionButtons: [
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            DownloadSearchPDFButton,
        ]),
    ],
    leftActionButtons: [TableViewButton],
    permanentFilters: {
        dehydrate_extra: ["foreign_key_names"],
        exclude_list_fields: "disbursements,receipts,links,legislator_committees,note",
    },
}

export const PacClassicPacTransactionFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PacClassicPacTransactionFilterableListView))

PacClassicPacTransactionFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value,
    inlineComponent: PacClassicPacTransactionInline,
    filterSetComponent: PersonifiedFilterSet(PacClassicPacTransactionFilterSet),
    searchPlaceholderText: "Search transactions (PAC)...",
    bulkActionsConsole: canDisplayBulkActionsConsole() ? BulkActionsConsole : undefined,
    actionButtons: [
        // OfficialVisualizationConsole && DisplayVisualizationsButton,
        createDownloadButtonGroup([
            DownloadSpreadsheetButton,
            DownloadExcelButton,
            DownloadWordButton,
            // DownloadSearchPDFButton TODO
        ]),
    ],
    leftActionButtons: [TableViewButton],
    permanentFilters: {
        dehydrate_extra: ["foreign_key_names"],
    },
}

export const PacTransactionInPacOrganizationProfileFilterableListView = (props) => {
    const profileId = props?.profileId

    const newProps = {
        ...props,
        permanentFilters: {
            ...props.permanentFilters,
            transaction_pac_organization: {
                addedIds: [profileId],
                deletedIds: [],
                querysetList: [],
            },
        },
    }

    return genericFilterableListView(mergeProps(newProps, PacTransactionInPacOrganizationProfileFilterableListView))
}

PacTransactionInPacOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    PacClassicPacTransactionFilterableListView.defaultProps,
    {
        filterSetComponent: PacClassicPacTransactionInPacOrgFilterSet,
    },
)

export const PacTransactionInOfficialProfileFilterableListView = (props) => {
    const profileId = props?.profileId

    const newProps = {
        ...props,
        permanentFilters: {
            ...props.permanentFilters,
            transaction_official: {
                addedIds: [profileId],
                deletedIds: [],
                querysetList: [],
            },
        },
    }

    return genericFilterableListView(mergeProps(newProps, PacTransactionInOfficialProfileFilterableListView))
}

PacTransactionInOfficialProfileFilterableListView.defaultProps = overrideDefaultProps(
    PacClassicPacTransactionFilterableListView.defaultProps,
    {
        filterSetComponent: PacClassicPacTransactionInOfficialFilterSet,
    },
)

export const PacTransactionInSupporterProfileFilterableListView = (props) => {
    const profileId = props?.profileId
    const newProps = {
        ...props,
        permanentFilters: {
            ...props.permanentFilters,
            transaction_supporter: {
                addedIds: [profileId],
                deletedIds: [],
                querysetList: [],
            },
        },
    }
    return genericFilterableListView(mergeProps(newProps, PacTransactionInSupporterProfileFilterableListView))
}
PacTransactionInSupporterProfileFilterableListView.defaultProps = overrideDefaultProps(
    PacClassicPacTransactionFilterableListView.defaultProps,
    {
        filterSetComponent: PacClassicPacTransactionInSupporterFilterSet,
    },
)

export const CampaignFinanceReceiptsFilterableListView = (props) => {
    let newProps = props
    let fec_ids = props?.id_new?.member?.fec_ids
    const fec_committee_ids = props?.id_new?.member?._extra?.political_committees.map((committee) => committee.fec_id)

    if (Array.isArray(fec_ids) && fec_ids.length === 0) {
        fec_ids = null
    }

    if (props?.dtvSections) {
        const newProfileId = props?.dtvSections?.[1]?.data?.[0]?.subtitle

        newProps = {
            ...props,
            profileId: newProfileId,
        }
    }

    if (fec_ids || fec_ids === null || Array.isArray(fec_ids)) {
        newProps = {
            ...props,
            permanentFilters: {
                ...newProps.permanentFilters,
                fec_ids,
                fec_committee_ids,
            },
        }
    }

    return genericFilterableListView(mergeProps(newProps, CampaignFinanceReceiptsFilterableListView))
}

CampaignFinanceReceiptsFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.receipt.value,
    resource: DjangIO.app.moneyball.models.Receipt,
    inlineComponent: CampaignFinanceReceiptDisabledInline,
    filterSetComponent: CampaignFinanceReceiptFilterSet,
    searchPlaceholderText: "Search receipts...",
    actionButtons: [createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton])],
    leftActionButtons: [TableViewButton, DisplayVisualizationsButton, SaveToListButton],
    permanentFilters: {
        source_type: "fec",
    },
    visualizationConsole: ReceiptsVisualizationConsole,
}

export const RecieptsSupproterFilterableListView = (props) => {
    return genericFilterableListView(mergeProps(props, RecieptsSupproterFilterableListView))
}

RecieptsSupproterFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.receipt.value,
    resource: DjangIO.app.moneyball.models.Receipt,
    inlineComponent: CampaignFinanceReceiptDisabledInline,
    filterSetComponent: CampaignFinanceReceiptFilterSet,
    searchPlaceholderText: "Search receipts...",
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

export const CampaignFinanceDisbursementsFilterableListView = (props) => {
    let newProps = props
    let fec_ids = props?.id_new?.member?.fec_ids
    const fec_committee_ids = props?.id_new?.member?._extra?.political_committees.map((committee) => committee.fec_id)

    if (Array.isArray(fec_ids) && fec_ids.length === 0) {
        fec_ids = null
    }

    if (props?.dtvSections) {
        const newProfileId = props?.dtvSections?.[1]?.data?.[0]?.subtitle

        newProps = {
            ...props,
            profileId: newProfileId,
        }
    }

    if (fec_ids || fec_ids === null || Array.isArray(fec_ids)) {
        newProps = {
            ...props,
            permanentFilters: {
                ...newProps.permanentFilters,
                fec_ids,
                fec_committee_ids,
            },
        }
    }

    return genericFilterableListView(mergeProps(newProps, CampaignFinanceDisbursementsFilterableListView))
}

CampaignFinanceDisbursementsFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.disbursement.value,
    resource: DjangIO.app.moneyball.models.Disbursement,
    inlineComponent: CampaignFinanceDisbursementDisabledInline,
    filterSetComponent: CampaignFinanceDisbursementsFilterSet,
    searchPlaceholderText: "Search disbursements...",
    actionButtons: [createDownloadButtonGroup([DownloadSpreadsheetButton, DownloadExcelButton, DownloadWordButton])],
    leftActionButtons: [TableViewButton, SaveToListButton],
}

export const CampaignFinanceDisbursementsFilterableListViewPowerSearch = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CampaignFinanceDisbursementsFilterableListViewPowerSearch))

CampaignFinanceDisbursementsFilterableListViewPowerSearch.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.cf_committee.value,
    resource: DjangIO.app.moneyball.models.CommitteesSuggester,
    inlineComponent: CampaignFinanceReceiptInline,
    labelPlural: "Political Committees",
    labelSingular: "Political Committees",
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

export const selectPoliticalCommitteeDtvValues = (state, props) => ({
    dtvSections: selectPoliticalCommitteeSections(state, props),
    id_new: politicalCommitteeProfileSelectorsMobile(state, props),
})

export const NewCampaignFinanceDisbursementsFilterableListView = connect(selectPoliticalCommitteeDtvValues)(
    CampaignFinanceDisbursementsFilterableListView,
)
export const NewCampaignFinanceReceiptsFilterableListView = connect(selectPoliticalCommitteeDtvValues)(
    CampaignFinanceReceiptsFilterableListView,
)

// Filter for Receipts Power Search
export const CampaignFinanceReceiptsContributorFilterableListViewFLVs = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CampaignFinanceReceiptsContributorFilterableListViewFLVs))

CampaignFinanceReceiptsContributorFilterableListViewFLVs.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.cf_committee.value,
    resource: DjangIO.app.moneyball.models.CommitteesSuggester,
    inlineComponent: CampaignFinanceReceiptInline,
    labelPlural: "Political Committees",
    labelSingular: "Political Committees",
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

// Filter for Receipts Power Search
export const CampaignFinanceReceiptsCandidatesFilterableListViewFLVs = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CampaignFinanceReceiptsCandidatesFilterableListViewFLVs))

CampaignFinanceReceiptsCandidatesFilterableListViewFLVs.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.moneyball.models.CandidatesSuggester,
    inlineComponent: CampaignFinanceReceiptInline,
    labelPlural: "Candidates",
    labelSingular: "Candidate",
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

// Filter for Receipts Power Search
export const CampaignFinanceReceiptsFilterableListViewFLVs = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CampaignFinanceReceiptsFilterableListViewFLVs))

CampaignFinanceReceiptsFilterableListViewFLVs.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.cf_committee.value,
    resource: DjangIO.app.moneyball.models.CommitteesSuggester,
    inlineComponent: CampaignFinanceReceiptInline,
    labelPlural: "Political Committees",
    labelSingular: "Political Committee",
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

// Filter for Disbursements Power Search
export const CampaignFinanceDisbursementsFilterableListViewFLVs = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CampaignFinanceDisbursementsFilterableListViewFLVs))

CampaignFinanceDisbursementsFilterableListViewFLVs.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.cf_committee.value,
    resource: DjangIO.app.moneyball.models.CommitteesSuggester,
    inlineComponent: CampaignFinanceDisbursementInline,
    labelPlural: "Political Committees",
    labelSingular: "Political Committee",
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

export const ElectionFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, ElectionFilterableListView))

ElectionFilterableListView.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.election.value,
    inlineComponent: ElectionInline,
    filterSetComponent: PersonifiedFilterSet(ElectionFilterSet),
    // empty array of actions so that TableViewButton is not hidden
    actionButtons: [],
    leftActionButtons: [TableViewButton],
}

/* ***************************************************************************
 * Selects-Turned-Searchify FLVs
 ***************************************************************************** */
export const AgencySearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, AgencySearchifyFLV))
AgencySearchifyFLV.defaultProps = {
    resource: DjangIO.app.reg.models.Agency,
    inlineComponent: AgencyInline,
    searchPlaceholderText: "Search agencies...",
    labelSingular: "Agency",
    labelPlural: "Agencies",
    filterSetComponent: AgencyFilterSet,
    permanentFilters: {
        unique_agencies: true,
    },
}

export const CampaignSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, CampaignSearchifyFLV))
CampaignSearchifyFLV.defaultProps = {
    resource: DjangIO.app.grassroots.campaign.models.Campaign,
    inlineComponent: CampaignInline,
    permanentFilters: {
        activated__isnull: false,
    },
    searchPlaceholderText: "Search campaigns by name...",
}

export const ActionCenterSettingsSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, ActionCenterSettingsSearchifyFLV))
ActionCenterSettingsSearchifyFLV.defaultProps = {
    resource: DjangIO.app.grassroots.models.ActionCenterSettings,
    inlineComponent: ActionCenterSettingsInline,
    permanentFilters: {
        activated__isnull: false,
    },
    searchPlaceholderText: "Search action centers by name...",
}

export const CanadianFederalElectoralDistrictSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CanadianFederalElectoralDistrictSearchifyFLV))
CanadianFederalElectoralDistrictSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.GeoShape,
    inlineComponent: GeoShapeInline,
    searchPlaceholderText: "Search federal electoral districts by name...",
    labelSingular: "Federal Electoral District",
    labelPlural: "Federal Electoral Districts",
    filterSetComponent: genericFilterSet,
}

export const CustomDataSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, CustomDataSearchifyFLV))
CustomDataSearchifyFLV.defaultProps = {
    resource: DjangIO.app.custom_data.manage_data.models.CustomData,
    inlineComponent: CustomDataInline,
    searchPlaceholderText: "Search footprint data...",
    labelSingular: "Footprint Data",
    labelPlural: "Footprint Data",
    filterSetComponent: CustomDataGeographicFilterSet,
}

export const CustomRegionSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, CustomRegionSearchifyFLV))
CustomRegionSearchifyFLV.defaultProps = {
    resource: DjangIO.app.custom_data.manage_data.models.CustomData,
    inlineComponent: CustomRegionInline,
    permanentFilters: {
        is_batch_data: false,
    },
    searchPlaceholderText: "Search custom regions...",
}

export const ExecutiveSearchifyFLV = (props) => genericFilterableListView(mergeProps(props, ExecutiveSearchifyFLV))
ExecutiveSearchifyFLV.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: ExecutiveFilterSet,
    // officials show every PersonType except staffers.
    permanentFilters: {
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.executive.value,
    },
    searchPlaceholderText: "Search executives...",
    labelSingular: "Executive",
    labelPlural: "Executives",
}

export const IssueSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, IssueSearchifyFLV))
IssueSearchifyFLV.defaultProps = {
    resource: DjangIO.app.bill.models.BillTerm,
    inlineComponent: IssueInline,
    searchPlaceholderText: "Search issues...",
    labelSingular: "Issue",
    labelPlural: "Issues",
    filterSetComponent: IssuesFilterSet,
    permanentFilters: {
        term_type: 2,
        dehydrate_extra: ["parents"],
    },
}

export const LegislativeSessionSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, LegislativeSessionSearchifyFLV))
LegislativeSessionSearchifyFLV.defaultProps = {
    resource: DjangIO.app.models.LegSession,
    inlineComponent: LegislativeSessionInline,
    labelSingular: "Session",
    labelPlural: "Sessions",
    searchPlaceholderText: "Search legislative sessions...",
}

export const LegislatorSearchifyFLV = (props) => genericFilterableListView(mergeProps(props, LegislatorSearchifyFLV))
LegislatorSearchifyFLV.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: LegislatorFilterSet,
    // officials show every PersonType except staffers.
    permanentFilters: {
        dehydrate_extra: ["most_recent_role"],
        most_recent_person_type__in: [
            DjangIO.app.person.types.PersonType.member.value,
            DjangIO.app.person.types.PersonType.local_member.value,
        ],
    },
    searchPlaceholderText: "Search legislators...",
    labelSingular: "Legislator",
    labelPlural: "Legislators",
}

export const LegislatorSearchifyWithoutCampaignFinanceFLV = (props) =>
    genericFilterableListView(mergeProps(props, LegislatorSearchifyWithoutCampaignFinanceFLV))
LegislatorSearchifyWithoutCampaignFinanceFLV.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: LegislatorFilterSetWithoutCampaignFinance,
    // officials show every PersonType except staffers.
    permanentFilters: {
        dehydrate_extra: ["most_recent_role"],
        most_recent_person_type__in: [
            DjangIO.app.person.types.PersonType.member.value,
            DjangIO.app.person.types.PersonType.local_member.value,
        ],
    },
    searchPlaceholderText: "Search legislators...",
    labelSingular: "Legislator",
    labelPlural: "Legislators",
}

export const SupporterLegislatorSearchifyFLV = (props) =>
    genericFilterableListView(mergeProps(props, SupporterLegislatorSearchifyFLV))
SupporterLegislatorSearchifyFLV.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: LegislatorFilterSetWithoutCampaignFinance,
    // officials show every PersonType except staffers.
    permanentFilters: {
        dehydrate_extra: ["most_recent_role"],
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.member.value,
        ph_current: true,
        ph_minor_role_type: [
            DjangIO.app.person.newtypes.MinorRoleType.us_senator.value,
            DjangIO.app.person.newtypes.MinorRoleType.us_representative.value,
        ],
    },
    searchPlaceholderText: "Search officials...",
    labelSingular: "Official",
    labelPlural: "Officials",
}

export const PoliticalCommitteeLegislatorSearchifyFLV = (props) =>
    genericFilterableListView(mergeProps(props, PoliticalCommitteeLegislatorSearchifyFLV))
PoliticalCommitteeLegislatorSearchifyFLV.defaultProps = {
    quorumDataType: DjangIO.app.models.QuorumDataType.person.value,
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: OfficialInline,
    filterSetComponent: LegislatorFilterSetWithoutCampaignFinance,
    // officials show every PersonType except staffers.
    permanentFilters: {
        dehydrate_extra: ["most_recent_role"],
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.member.value,
        ph_current: true,
        ph_minor_role_type: [
            DjangIO.app.person.newtypes.MinorRoleType.us_senator.value,
            DjangIO.app.person.newtypes.MinorRoleType.us_representative.value,
        ],
    },
    searchPlaceholderText: "Search officials...",
    labelSingular: "Official",
    labelPlural: "Officials",
}

export const OrganizationSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, OrganizationSearchifyFLV))
OrganizationSearchifyFLV.defaultProps = {
    resource: DjangIO.app.userdata.models.Organization,
    inlineComponent: OrganizationInline,
    searchPlaceholderText: "Search organizations...",
    labelSingular: "Organization",
    labelPlural: "Organizations",
    filterSetComponent: genericFilterSet,
}

export const StafferTermSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, StafferTermSearchifyFLV))
StafferTermSearchifyFLV.defaultProps = {
    resource: DjangIO.app.person.models.StafferTerm,
    inlineComponent: StafferTermInline,
    searchPlaceholderText: "Search issues...",
    labelSingular: "Issue",
    labelPlural: "Issues",
    permanentFilters: {
        term_type: 2,
    },
}

export const StafferTitleSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, StafferTitleSearchifyFLV))
StafferTitleSearchifyFLV.defaultProps = {
    resource: DjangIO.app.person.models.StaffTitle,
    inlineComponent: StafferTitleInline,
    searchPlaceholderText: "Search staffer titles...",
    labelSingular: "Title",
    labelPlural: "Titles",
}

export const TeamSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, TeamSearchifyFLV))
TeamSearchifyFLV.defaultProps = {
    resource: DjangIO.app.userdata.models.Team,
    inlineComponent: TeamInline,
    searchPlaceholderText: "Search teams...",
    labelSingular: "Team",
    labelPlural: "Teams",
    filterSetComponent: TeamFilterSet,
    permanentFilters: {
        dehydrate_extra: ["organization"],
    },
}

export const WitnessSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, WitnessSearchifyFLV))
WitnessSearchifyFLV.defaultProps = {
    resource: DjangIO.app.committee.models.CommitteeWitness,
    inlineComponent: WitnessInline,
    searchPlaceholderText: "Search witnesses by name...",
}

// geography searchify FLVs
export const CountrySearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, CountrySearchifyFLV))
CountrySearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.Country,
    inlineComponent: CountryInline,
    searchPlaceholderText: "Search countries by name...",
    labelSingular: "Country",
    labelPlural: "Country",
}

export const CountySearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, CountySearchifyFLV))
CountySearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.County,
    inlineComponent: CountyInline,
    searchPlaceholderText: "Search counties by name...",
    labelSingular: "County",
    labelPlural: "County",
    filterSetComponent: GeographyFilterSet,
}

export const DistrictSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, DistrictSearchifyFLV))
DistrictSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.District,
    inlineComponent: DistrictInline,
    searchPlaceholderText: "Search districts by name...",
    labelSingular: "District",
    labelPlural: "Districts",
    filterSetComponent: GeographyFilterSet,
}

export const LowerLDSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, LowerLDSearchifyFLV))
LowerLDSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.LowerLD,
    inlineComponent: LowerLDInline,
    searchPlaceholderText: "Search lower LDs by name...",
    labelSingular: "Lower Legislative District",
    labelPlural: "Lower Legislative Districts",
    filterSetComponent: GeographyFilterSet,
}

export const MunicipalitySearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, MunicipalitySearchifyFLV))
MunicipalitySearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.Municipality,
    inlineComponent: MunicipalityInline,
    searchPlaceholderText: "Search towns and cities by name...",
    labelSingular: "Municipality",
    labelPlural: "Municipalities",
    filterSetComponent: GeographyMunicipalityFilterSet,
}

export const StateSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, StateSearchifyFLV))
StateSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.State,
    inlineComponent: StateInline,
    searchPlaceholderText: "Search states by name...",
    labelSingular: "State",
    labelPlural: "States",
    filterSetComponent: GeographyStateFilterSet,
}

export const SendEmailArchivedSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, SendEmailArchivedSearchifyFLV))
SendEmailArchivedSearchifyFLV.defaultProps = {
    resource: DjangIO.app.userdata.outbox.models.send_email.SendEmailArchived,
    inlineComponent: SendEmailInline,
    searchPlaceholderText: "Search sent emails by content...",
    labelSingular: "Outbox Email (Archived)",
    labelPlural: "Outbox Emails (Archived)",
    filterSetComponent: SendEmailFilterSet,
    permanentFilters: {
        dehydrate_extra: ["bulk_email"],
    },
}

export const UpperLDSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, UpperLDSearchifyFLV))
UpperLDSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.UpperLD,
    inlineComponent: UpperLDInline,
    searchPlaceholderText: "Search upper LDs by name...",
    labelSingular: "Upper Legislative District",
    labelPlural: "Upper Legislative Districts",
    filterSetComponent: GeographyFilterSet,
}

export const GeoShapeSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, GeoShapeSearchifyFLV))
GeoShapeSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.GeoShape,
    inlineComponent: GeoShapeInline,
    searchPlaceholderText: "Search Geographies by name...",
    labelSingular: "Geography",
    labelPlural: "Geographies",
    filterSetComponent: GeoShapeFilterSet,
    permanentFilters: {
        filter_region_for_dlc: true,
    },
}

export const GeoShapeForBriefBuilderSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, GeoShapeForBriefBuilderSearchifyFLV))
GeoShapeForBriefBuilderSearchifyFLV.defaultProps = {
    resource: DjangIO.app.geography.models.GeoShape,
    inlineComponent: GeoShapeInline,
    searchPlaceholderText: "Search Geographies by name...",
    labelSingular: "Geography",
    labelPlural: "Geographies",
    filterSetComponent: GeoShapeForBriefBuilderFilterSet,
    permanentFilters: {
        filter_region_for_brief_builder: true,
    },
}

// make this exclusive for lists because some models have multiple options for FLVs
export const listFLVDict = {
    [DjangIO.app.models.QuorumDataType.bill.value]: BillFilterableListView,
    [DjangIO.app.models.QuorumDataType.document.value]: DocumentFilterableListView,
    [DjangIO.app.models.QuorumDataType.person.value]: OfficialFilterableListView,
    [DjangIO.app.models.QuorumDataType.staffer.value]: StafferFilterableListView,
    [DjangIO.app.models.QuorumDataType.supporter.value]: SupporterFilterableListView,
    [DjangIO.app.models.QuorumDataType.note.value]: NoteFilterableListView,
    [DjangIO.app.models.QuorumDataType.grassroots_action]: GrassrootsActionFilterableListView,
    [DjangIO.app.models.QuorumDataType.event.value]: EventFilterableListView,
    [DjangIO.app.models.QuorumDataType.vote.value]: VoteFilterableListView,
    [DjangIO.app.models.QuorumDataType.amendment.value]: AmendmentFilterableListView,
    [DjangIO.app.models.QuorumDataType.regulation.value]: RegulationFilterableListView,
    [DjangIO.app.models.QuorumDataType.committee.value]: CommitteeFilterableListView,
    [DjangIO.app.models.QuorumDataType.caucus.value]: CaucusFilterableListView,
    [DjangIO.app.models.QuorumDataType.public_organization.value]: PublicOrganizationFilterableListView,
    [DjangIO.app.models.QuorumDataType.attachment.value]: AttachmentFilterableListView,
    [DjangIO.app.models.QuorumDataType.assignment.value]: AssignmentFilterableListView,
    [DjangIO.app.models.QuorumDataType.docket.value]: DocketFilterableListView,
    ...(isFeatureEnabled("ff_regcomment_flv_enabled")
        ? { [DjangIO.app.models.QuorumDataType.reg_comment.value]: RegulationCommentFilterableListView }
        : {}),
    [DjangIO.app.models.QuorumDataType.media.value]: ArticleFilterableListView,
    [DjangIO.app.models.QuorumDataType.send_email.value]: SendEmailFilterableListView,
    [DjangIO.app.models.QuorumDataType.press_contact.value]: PressContactFilterableListView,
}

/*
 PROFILE SPECIFIC FILTERABLE LIST VIEWS
 (To be moved to a separate file at a later date)
*/
export const AmendmentInCommitteeProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, AmendmentInCommitteeProfileFilterableListView))
AmendmentInCommitteeProfileFilterableListView.defaultProps = overrideDefaultProps(
    AmendmentFilterableListView.defaultProps,
    { filterSetComponent: AmendmentInCommitteeProfileFilterSet },
)

export const BillInCommitteeProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, BillInCommitteeProfileFilterableListView))
BillInCommitteeProfileFilterableListView.defaultProps = overrideDefaultProps(BillFilterableListView.defaultProps, {
    filterSetComponent: BillInCommitteeProfileFilterSet,
})

export const BillInOfficialProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, BillInOfficialProfileFilterableListView))
BillInOfficialProfileFilterableListView.defaultProps = overrideDefaultProps(BillFilterableListView.defaultProps, {
    filterSetComponent: BillInOfficialProfileFilterSet,
})

export const BillInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, BillInOrganizationProfileFilterableListView))
BillInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(BillFilterableListView.defaultProps, {
    filterSetComponent: BillInOrganizationProfileFilterSet,
})

export const DocumentExcludeSourceFilterableListView = (props) =>
    genericFilterableListView(mergeProps({ ...props, initialFilters: {} }, DocumentExcludeSourceFilterableListView))
DocumentExcludeSourceFilterableListView.defaultProps = overrideDefaultProps(DocumentFilterableListView.defaultProps, {
    filterSetComponent: DocumentExcludeSourceFilterSet,
})

export const SocialDocumentFilterableListView = (props) =>
    genericFilterableListView(mergeProps({ ...props, initialFilters: {} }, SocialDocumentFilterableListView))
SocialDocumentFilterableListView.defaultProps = overrideDefaultProps(DocumentFilterableListView.defaultProps, {
    filterSetComponent: SocialDocumentFilterSet,
    permanentFilters: {
        document_type__in: DjangIO.app.document.models.DocumentType.filter_groups.find(
            (group) => group.title === "Social",
        ).values,
    },
})

export const DocumentInCommitteeProfileFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps({ ...props, initialFilters: {} }, DocumentInCommitteeProfileFilterableListView),
    )
DocumentInCommitteeProfileFilterableListView.defaultProps = overrideDefaultProps(
    DocumentFilterableListView.defaultProps,
    { filterSetComponent: DocumentInCommitteeProfileFilterSet },
)

export const DocumentInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps({ ...props, initialFilters: {} }, DocumentInOrganizationProfileFilterableListView),
    )
DocumentInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    DocumentFilterableListView.defaultProps,
    { filterSetComponent: DocumentInOrganizationProfileFilterSet },
)

export const DocumentMembersInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps({ ...props, initialFilters: {} }, DocumentMembersInOrganizationProfileFilterableListView),
    )
DocumentMembersInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    DocumentFilterableListView.defaultProps,
    { filterSetComponent: DocumentMembersInOrganizationProfileFilterSet },
)

export const EventInCommitteeProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, EventInCommitteeProfileFilterableListView))
EventInCommitteeProfileFilterableListView.defaultProps = overrideDefaultProps(EventFilterableListView.defaultProps, {
    filterSetComponent: EventInCommitteeProfileFilterSet,
})

export const EventInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, EventInOrganizationProfileFilterableListView))
EventInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(EventFilterableListView.defaultProps, {
    filterSetComponent: EventInOrganizationProfileFilterSet,
})

export const GrassrootsActionInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, GrassrootsActionInOrganizationProfileFilterableListView))
GrassrootsActionInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    GrassrootsActionFilterableListView.defaultProps,
    { filterSetComponent: GrassrootsActionInOrganizationProfileFilterSet },
)

export const NoteInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(
        mergeProps(
            {
                ...props,
                actionButtons: [createAddNoteButtonGroup(props), ...props.actionButtons],
            },
            NoteInOrganizationProfileFilterableListView,
        ),
    )
NoteInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(NoteFilterableListView.defaultProps, {
    filterSetComponent: NoteInOrganizationProfileFilterSet,
})

export const NoteInCalendarEventWidgetFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, NoteInCalendarEventWidgetFilterableListView))
NoteInCalendarEventWidgetFilterableListView.defaultProps = overrideDefaultProps(NoteFilterableListView.defaultProps, {
    filterSetComponent: NoteInCalendarEventWidgetFilterSet,
    permanentFilters: { note_type__in: [DjangIO.app.userdata.types.NoteType.interaction.value] },
})

export const OfficialInBillProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, OfficialInBillProfileFilterableListView))
OfficialInBillProfileFilterableListView.defaultProps = overrideDefaultProps(OfficialFilterableListView.defaultProps, {
    filterSetComponent: OfficialInBillProfileFilterSet,
})

export const OfficialInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, OfficialInOrganizationProfileFilterableListView))
OfficialInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    OfficialFilterableListView.defaultProps,
    { filterSetComponent: OfficialInOrganizationProfileFilterSet },
)

export const OfficialInOutboxFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, OfficialInOutboxFilterableListView))
OfficialInOutboxFilterableListView.defaultProps = overrideDefaultProps(OfficialFilterableListView.defaultProps, {
    filterSetComponent: OfficialInOutboxFilterSet,
    permanentFilters: {
        dehydrate_extra: ["most_recent_role"],
        most_recent_person_type__in: DjangIO.app.person.types.PersonType.items()
            .filter((val) => val.is_official)
            .map((val) => val.value),
        ...(shouldHideLocalOfficialsContact()
            ? {
                  most_recent_region__in: DjangIO.app.models.Region.items()
                      .filter((item) => !DjangIO.app.models.SupportedRegion.local.child_regions.includes(item.value))
                      .map((item) => item.value),
              }
            : {}),
    },
})

export const PublicOrganizationInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PublicOrganizationInOrganizationProfileFilterableListView))
PublicOrganizationInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    PublicOrganizationFilterableListView.defaultProps,
    { filterSetComponent: PublicOrganizationInOrganizationProfileFilterSet },
)

export const StafferInCommitteeProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, StafferInCommitteeProfileFilterableListView))
StafferInCommitteeProfileFilterableListView.defaultProps = overrideDefaultProps(
    StafferFilterableListView.defaultProps,
    { filterSetComponent: StafferInCommitteeProfileFilterSet },
)

export const StafferInOfficialProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, StafferInOfficialProfileFilterableListView))
StafferInOfficialProfileFilterableListView.defaultProps = overrideDefaultProps(StafferFilterableListView.defaultProps, {
    filterSetComponent: StafferInOfficialProfileFilterSet,
})

export const SupporterInOrganizationProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, SupporterInOrganizationProfileFilterableListView))
SupporterInOrganizationProfileFilterableListView.defaultProps = overrideDefaultProps(
    SupporterFilterableListView.defaultProps,
    { filterSetComponent: SupporterInOrganizationProfileFilterSet },
)

export const VoteInBillProfileFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, VoteInBillProfileFilterableListView))
VoteInBillProfileFilterableListView.defaultProps = overrideDefaultProps(VoteFilterableListView.defaultProps, {
    filterSetComponent: VoteInBillProfileFilterSet,
})

export const PublicOrganizationPartyFilterableListView = (props) =>
    genericFilterableListView(mergeProps(props, PublicOrganizationPartyFilterableListView))
PublicOrganizationPartyFilterableListView.defaultProps = overrideDefaultProps(
    PublicOrganizationFilterableListView.defaultProps,
    {
        // it would be overkill to define an entire qdt for this
        labelPlural: "Parties",
        labelSingular: "Party",
        searchPlaceholderText: "Search parties...",
    },
)

export const MediaOutletSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, MediaOutletSearchifyFLV))
MediaOutletSearchifyFLV.defaultProps = {
    resource: DjangIO.app.person.models.PublicOrganization,
    inlineComponent: PublicOrganizationInline,
    searchPlaceholderText: "Search articles by outlet...",
    labelSingular: "Outlet",
    labelPlural: "Outlets",
    // Allows us to call PublicOrganization.objects.for_media(lexis=True)
    permanentFilters: { for_media_monitoring: true },
}

export const ArticleTopicSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, ArticleTopicSearchifyFLV))
ArticleTopicSearchifyFLV.defaultProps = {
    inlineComponent: ArticleTopicInline,
    filterSetComponent: ArticleTopicFilterSet,
    labelPlural: "Topics/Subtopics",
    labelSingular: "Topic/Subtopic",
    resource: DjangIO.app.media_monitoring.models.ArticleTopic,
    searchPlaceholderText: "Search articles by topic/subtopics...",
}

export const BeatSearchifyFLV = (props) => genericSearchifySelectFLV(mergeProps(props, BeatSearchifyFLV))
BeatSearchifyFLV.defaultProps = {
    resource: DjangIO.app.media_monitoring.models.Beat,
    inlineComponent: BeatInline,
    searchPlaceholderText: "Search beats...",
    labelSingular: "Beat",
    labelPlural: "Beats",
    permanentFilters: {},
}

export const PressContactSearchifyFLV = (props) =>
    genericSearchifySelectFLV(mergeProps(props, PressContactSearchifyFLV))
PressContactSearchifyFLV.defaultProps = {
    resource: DjangIO.app.person.models.NewPerson,
    inlineComponent: PressContactInline,
    searchPlaceholderText: "Search press...",
    labelSingular: DjangIO.app.models.QuorumDataType.press_contact.singular,
    labelPlural: DjangIO.app.models.QuorumDataType.press_contact.plural,
    filterSetComponent: PressContactFilterSet,
    permanentFilters: {
        most_recent_person_type: DjangIO.app.person.types.PersonType.press_contact.value,
        dehydrate_extra: ["media_organizations", "beats"],
    },
}
